import { memo } from 'react';
import { Tooltip } from 'antd';
import { EditSvg } from '@/assets/icons';
import Button from '@/components/button';
import Panel from '@/components/panel';

const GroupBio = ({ groupData, permissions }) => {
  return (
    <Panel
      title="Sibling Group Bio"
      extra={
        permissions.adminStaffAndSuper && (
        <Tooltip title="Edit Family Status">
          <Button type="link" icon={<EditSvg fontSize="16" />} to="../edit" />
        </Tooltip>
        )
      }
    >
      {groupData.bio}
    </Panel>
  );
};

export default memo(GroupBio);
